import { Aseguradora, AseguradoraFiltro, AseguradoraPageResponse } from '../../model/aseguradora/aseguradora';

/**
 * Puerto Abstracto: AseguradoraRepository
 * 
 * Define el contrato para gestión de aseguradoras (clientes).
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpAseguradoraRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class AseguradoraRepository {

  /**
   * Busca aseguradoras activas con filtros opcionales y paginación por
   * cursor (keyset pagination, ver skill acceso-datos-oracle §7).
   * Solo retorna aseguradoras activas (FEBAJA IS NULL).
   *
   * @param filtro Filtros de búsqueda (tipoId, numeroId, nombre)
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param direction NEXT | PREVIOUS | LAST
   * @returns Página de aseguradoras
   */
  abstract buscarAseguradoras(
    filtro: AseguradoraFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<AseguradoraPageResponse>;

  /**
   * Obtiene una aseguradora por su NIT.
   * Usado para cargar la aseguradora por defecto (NIT 800256161).
   * 
   * @param nit Número de identificación
   * @returns Aseguradora encontrada
   */
  abstract obtenerAseguradoraPorNit(nit: string): Promise<Aseguradora>;

  /**
   * Obtiene la aseguradora por defecto asociada al usuario logueado.
   *
   * Legacy: ApplicationCommonData.searchDefaultClient()
   * Usa contrato dedicado en backend para resolver CLIENTE_DEFAULT_CIA
   * y retornar la aseguradora por defecto.
   *
   * @returns Aseguradora por defecto, o null si no está configurada o no se encuentra.
   */
  abstract obtenerAseguradoraDefault(): Promise<Aseguradora | null>;
}
